import { ListGroupItem, FormGroup, Radio } from "react-bootstrap";
import { IEmailFlag } from "@nkr/models/index";
import styled from "styled-components";

const RadioWrapper = styled(Radio)`
    & > input {
        margin-top: 0px;
        margin-bottom: 0px;
    }
`;

interface IProps {
    groupIndex: number,
    itemIndex: number,
    flag: IEmailFlag,
    value: number,
    onChange: (flagId: number, value: number) => void
}

const EmailOptionItem = (props: IProps) => {
    const handleYes = () => {
        props.onChange(props.flag.id, 1);
    }

    const handleNo = () => {
        props.onChange(props.flag.id, 0);
    }

    const isYes = props.value > 0;

    return (
        <ListGroupItem style={{ fontSize: 12, display: "flex", justifyContent: "space-between" }}>
            <div>{props.flag.name}</div>

            <div>
                <FormGroup style={{ marginBottom: 0 }}>
                    <RadioWrapper name={`radioGroup-${props.groupIndex}-${props.itemIndex}`} checked={isYes} inline onClick={handleYes}>Yes</RadioWrapper>{' '}
                    <RadioWrapper name={`radioGroup-${props.groupIndex}-${props.itemIndex}`} checked={!isYes} inline onClick={handleNo}>No</RadioWrapper>{' '}
                </FormGroup>
            </div>
        </ListGroupItem>
    );
}

export default EmailOptionItem;